import { useTranslation } from 'react-i18next';
import { useUIStore } from '../stores/uiStore';
import { cn } from '../lib/utils';

export default function LanguageToggle({ className }) {
  const { i18n } = useTranslation();
  const { language, toggleLanguage } = useUIStore();

  const handleToggle = () => {
    const next = language === 'ar' ? 'en' : 'ar';
    toggleLanguage();
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={handleToggle}
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium',
        'border border-gray-300 bg-white text-gray-700',
        'hover:bg-gray-50 transition-colors duration-150',
        className
      )}
      title={language === 'ar' ? 'Switch to English' : 'التبديل للعربية'}
    >
      <span className={cn(language === 'ar' ? 'font-bold text-primary-600' : 'text-gray-400')}>
        ع
      </span>
      <span className="text-gray-300">|</span>
      <span className={cn(language === 'en' ? 'font-bold text-primary-600' : 'text-gray-400')}>
        EN
      </span>
    </button>
  );
}
